import React, {
  Component
}                     from 'react';
import PropTypes      from 'prop-types';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Modal,
  ButtonGroup,
  DropdownButton,
  MenuItem,
  Label
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
//import Alert          from '../../../components/alert/Alert';
import { createBrowserHistory } from 'history';
import {
  NewBreadcrumb as BreadcrumbComponent
}                        from '../../../components';

// include action file for add merchant
import '../../../style/subAdmin/SubAdmin.scss';
import { Notification } from '../../../components/notifications';
import isEmpty from 'lodash.isempty';
import { getCountry } from '../../../redux/actions/countryCityActions';
import { notification,} from '../../../redux/actions/emailManagerActions';
import {renderAlert, clearAlert} from '../../../redux/actions/alertsActions';
import moment from 'moment';
import loader from '../../../style/loader/loader.scss'; 
//import '../../../style/react-datetimepicker.scss';

import Pagination from 'react-paginating';
const history = createBrowserHistory();

const HorizontalLine = ({ }) => (
    <hr/>
);

const propTypes = {
    notification: PropTypes.func.isRequired,
};
let cityItems=[];let isLoading="false",  csvData = [];

class NotificationList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props){

    super(props);
    this.state={
      path: ['Home', 'Notification'], 
      links: ["home",'notification/list'],
      date: new Date(),
      range: false,
      disabled: false,
      cityID: '',
      isLoading: 'false',
      notificationList: '',
      alertMessage: '',
      show: false,
      totalRecords: 0,
      perPage: 0,
      limit:25,
      currentPage: 1,
      pageCount:0,
      countryName: 'US',
      country: '',
    }   

  }

  handlePageChange = page => {
    isLoading="true";
    this.setState({
      currentPage: page
    });
    this.props.notification({page:page,limit: this.state.limit, countryName: 'US'});
    // this.props.getSiteCity();
  };

  handleChange = (e) => {
  	isLoading="true";
    this.setState({[e.target.name] : e.target.value});
    this.props.notification({page:this.state.currentPage,limit: this.state.limit, countryName: e.target.value});
  }

  componentWillMount(){
  	isLoading = "true";
    this.handlePageChange();
    this.props.getCountry();
  }

  componentWillReceiveProps(nextProps){  
      if(this.props.error !== nextProps.error){
        if(nextProps.error){
          this.props.clearAlert ();
          this.props.renderAlert('warning',nextProps.error);
          isLoading="false";
        }
      }

      if (this.props.country !== nextProps.country){
	      if(nextProps.country){
	        isLoading = "false";
	        this.setState({country: nextProps.country});
	      }
	  }

      if(this.props.notificationList !== nextProps.notificationList){
        if(nextProps.notificationList){
          isLoading="false";
          const setPageCount = nextProps.notificationList.data.total / nextProps.notificationList.data.per_page;
          this.setState({notificationList: nextProps.notificationList.data, totalRecords:nextProps.notificationList.data.total, perPage:nextProps.notificationList.data.per_page, pageCount:setPageCount})
        }
      }

      if(nextProps.message){
        this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
      }
}

  render() {
    const { currentPage,totalRecords,perPage,pageCount } = this.state;    
    return (
      <div className="col-lg-12 add-sub-admin">
        {(isLoading =='true') ? 
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        }
       
        <div className="row">
          <div className="col-xs-12">
             <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">
              <div className="row">
                <div className="col-lg-6 col-md-4 col-sm-12">
                  <h4>Notification List</h4>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
              	  <FormGroup controlId="formCountry">
	               <FormControl componentClass="select" name="countryName" value={this.state.countryName} placeholder="select" onChange={this.handleChange} style={{borderColor:this.state.countryNameError}}>
				      <option value="">Select Country</option>
                      {(this.state.country) &&
                        this.state.country.map((data, index) => 
                        <option value={data.country}>{data.countryName}</option>
                        )
                      }
					</FormControl>
				   </FormGroup>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-12">
                    <Button className="addMerchant"
                      bsSize="small"
                      bsStyle="success"
                      onClick={() => this.context.router.history.push("/notification/add")}
                    >
                      + Add New Notification
                    </Button>
                </div>
              </div>
            </header>
          <div className="panel-body">
          {this.state.show && this.state.alertMessage !=='' &&        
            <div className="col-lg-12">
              <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
              <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
            </Alert>
            </div>
          }
          <table className="table table-hover table-bordered">
            <thead>
              <tr>
                <th>City</th>
                <th>Message</th>
                <th>Position</th>
                <th>Started At</th>
                <th>Ended At</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
                {(!isEmpty(this.state.notificationList.data)) ? 
                  this.state.notificationList.data.map((data, index) => 
                    <tr key={index}>
                      <td>{data.city}</td>
                      <td>{data.message}</td>
                      <td>{(data.position == 'top') ? "Top" : "3rd Offer Position"}</td>
                      <td>{moment(data.startedAt).format("ll hh:mm A")}</td>
                      <td>{moment(data.endedAt).format("ll hh:mm A")}</td>
                      <td>{(data.status == 'live') ? 'Live' : 'Inactive'}</td>
                      <td>
                        <ButtonGroup>
                          <DropdownButton title="Action" id="bg-nested-dropdown">
                            <MenuItem eventKey={Math.random()} data-key={index} onClick={() => this.context.router.history.push(`/notification/edit/${data.notificationID}`)}><i className="glyphicon glyphicon-eye-open"></i> Edit</MenuItem>
                          </DropdownButton>
                      </ButtonGroup>
                      </td>
                    </tr>
                  )
                :
                <tr><td colSpan="7" className="text-center">Data Not Found</td></tr>
                }
            </tbody>
          </table>
          <div className="text-center">
                <Pagination
                  total={totalRecords}
                  limit={perPage}
                  pageCount={5}
                  currentPage={currentPage}
                >
                  {({
                    pages,
                    currentPage,
                    hasNextPage,
                    hasPreviousPage,
                    previousPage,
                    nextPage,
                    totalPages,
                    getPageItemProps
                  }) => (
                    <div className="pagination">
                      <button
                        {...getPageItemProps({
                          pageValue: 1,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        first
                      </button>

                      {hasPreviousPage && (
                        <button
                          {...getPageItemProps({
                            pageValue: previousPage,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {'<'}
                        </button>
                      )}

                      {pages.map(page => {
                        let activePage = null;
                        if (currentPage === page) {
                          activePage = { backgroundColor: '#ccc', color: '#666' };
                        }
                        return (
                          <button
                            key={page}
                            style={activePage}
                            {...getPageItemProps({
                              pageValue: page,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {page}
                          </button>
                        );
                      })}

                      {hasNextPage && (
                        <button
                          {...getPageItemProps({
                            pageValue: nextPage,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {'>'}
                        </button>
                      )}

                      <button
                        {...getPageItemProps({
                          pageValue: totalPages,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        last
                      </button>
                    </div>
                  )}
                </Pagination>
                </div>
          </div>
        </div>       
      </div>
    );
  }
}
 
 

const mapStateToProps = (state,ownProps) => {
    return {
      error: state.emailManagerReducer.error,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message,
      notificationList:  state.emailManagerReducer.emailList,
      country: state.countryCityReducers.countries,
    };
};

export default compose(
  withRouter, 
  connect(mapStateToProps, {renderAlert, clearAlert, notification, getCountry})
)(NotificationList);



// WEBPACK FOOTER //
// ./src/app/views/admin/notification/NotificationList.js